import { Grid, Typography } from "@material-ui/core";
import { lang } from "i18nLang";
import {
  BorderLinearProgress,
  GridDetails,
  GridProcess,
  Message,
  Title,
} from "./style";

interface IPropsProgress {
  /** Progresso atual da importação */
  progress: number;
  /** Mensagem do estado */
  message: string;
  /** Detalhes do progresso */
  detailMessage: string;
  /** Eestimativa de tempo restante para concluir a importação */
  timeLeft: string;
}

/** Etapa na qual são exibidas os dados do progresso da importação do contrato.
 * @category Components
 */
const ProgressLayer = (props: IPropsProgress) => (
  <Grid
    container
    direction="column"
    justifyContent="center"
    alignItems="center"
  >
    <Grid item>
      <Typography
        variant="h3"
        style={{ fontWeight: 300 }}
      >{`${props.progress}%`}</Typography>
    </Grid>
    <GridDetails item>
      <Title>{props.message}</Title>
      <Typography variant="caption">
        {`${lang("timeLeft")}: ${props.timeLeft}`}
      </Typography>
    </GridDetails>
    <GridProcess item>
      <BorderLinearProgress variant="determinate" value={props.progress} />
    </GridProcess>
    <GridDetails item xs={8}>
      <Message variant="caption">{props.detailMessage}</Message>
    </GridDetails>
  </Grid>
);

export default ProgressLayer;
